import React, { useEffect, useState } from "react";
import { IPetsDashboardResponseModel } from "../../../../typings/models/PetsDashboardResponseModel";
import { useNavigate, Link } from "react-router-dom";
import { IOwnerStatus } from "../../../../typings/models/OwnerStatus";
import { ownerChangeToNewOwner } from "../../../../api/apimethods";
import moment from "moment";

interface RegGridRowProps {
  data: any;
  onRemoveItem: (item: any) => void;
}

const PetsGridRow: React.FC<RegGridRowProps & { activeButton: string }> = ({
  data,
  onRemoveItem,
  activeButton,
}) => {
  let navigate = useNavigate();

  const handlePetsEditClick = () => {
    navigate("/application-for-pets", {
      state: {
        petsRegistrationId: data.petsRegistrationId,
        buttonId: "v-pills-petsregedit-tab",
        tabId: "v-pills-petsregedit",
        bannerId: 7,
      },
    });
  };

  return (
    <tr>
      <td className="center-content">
        <a href="#" onClick={handlePetsEditClick} className="link-style">
          {data.referenceNo}
        </a>
      </td>
      <td>{data.applicationType}</td>
      <td>{data.animalType}</td>
      <td>{data.breed && data.breed.replace(/ *\[[^\]]*]/, "")}</td>
      <td>{data.petsMicrochipNo}</td>
      <td>{data.petsName}</td>
      <td>
        {(data.petsOrigin === "1" && "Local") ||
          (data.petsOrigin === "2" && "Overseas")}
      </td>
      <td>{data.ownerName}</td>
      <td>{data.petStatusString}</td>
      <td>{data.registrationStatusString}</td>
      <td>{moment(data.submittedDate).format("DD/MM/yyyy, hh:mm a")}</td>
    </tr>
  );
};

export default PetsGridRow;
